import { createSlice } from "@reduxjs/toolkit";
import appConst from '../Utilities/appConst.json';

const alertSlice = createSlice({
    name: 'alert',
    initialState: {
        open: false,
        title: "",
        message: "",
        isDialog: false,
        isInput: false,
        callbackFuncYes: null,
        callbackFuncNo: null,
        yesButtonText: appConst.YES,
        noButtonText: appConst.NO,
        okButtonText: appConst.OK,
        hasNext: false,
        nextDialogTitle: "",
        nextDialogMessage: "",
        nextDialogOkButtonText: appConst.OK,
        hasScrollTo: false,
        shouldScrollTo: false,
        isError: false,
        helperText: ""
    },
    reducers: {
        createAlert: (state, action) => {
            state.callbackFuncYes = action.payload.funcYes
            state.callbackFuncNo = action.payload.funcNo
            state.open = true;
            state.title = action.payload.title;
            state.message = action.payload.message;
            state.isInput = action.payload.isInput;
            state.isDialog = action.payload.isDialog;
            state.yesButtonText = action.payload.yesButtonText || state.yesButtonText;
            state.noButtonText = action.payload.noButtonText || state.noButtonText;
            state.okButtonText = action.payload.okButtonText || state.okButtonText;
            state.hasNext = action.payload.hasNext || false;
            if (action.payload.hasNext) {
                state.nextDialogTitle = action.payload.nextDialogTitle;
                state.nextDialogMessage = action.payload.nextDialogMessage;
                state.nextDialogOkButtonText = action.payload.nextDialogOkButtonText || state.nextDialogOkButtonText;
            }
            state.hasScrollTo = action.payload.hasScrollTo;
            state.shouldScrollTo = false;
            state.isError = false;
            state.helperText = "";
        },
        closeAlert: (state, action) => {
            state.open = false;
            state.title = "";
            state.message = "";
            if (action.payload === appConst.YES && state.callbackFuncYes) {
                state.callbackFuncYes();
            }
            else if (action.payload === appConst.NO && state.callbackFuncNo) {
                state.callbackFuncNo();
            }
            else if (action.payload === appConst.OK && state.callbackFuncYes) {
                state.callbackFuncYes();
            }
        },
        submitInput: (state, action) => {
            state.callbackFuncYes(action.payload);
        },
        setShouldScrollTo: (state, action) => {
            state.shouldScrollTo = action.payload;
        },
        setIsError: (state, action) => {
            state.isError = !action.payload.isValid;
            state.helperText = action.payload.errorMessage;
        }
    }
});


export const alertActions = alertSlice.actions;
export default alertSlice;
